import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormControl,
    FormLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    InputLabel,
    TextField,
    Box,
} from '@mui/material';
import axios from "axios";
import {getBearerToken, getServerUrl} from "./utils/utils";


function TripPicturesSlideshowModal({ open, onClose }) {
    const [step, setStep] = useState(1);
    const [type, setType] = useState('Trips');
    const [tripOrder, setTripOrder] = useState('random')
    const [filter, setFilter] = useState('All');
    const [category, setCategory] = useState('');
    const [friends, setFriends] = useState([]);
    const [friendsList, setFriendsList] = useState([])
    const [startYear, setStartYear] = useState(2025);
    const [endYear, setEndYear] = useState(2025);
    const [slideshowTitle, setSlideshowTitle] = useState("")
    const [shouldShowSlideshowTitle, setShouldShowSlideshowTitle] = useState('no')
    const [uploadUserType, setUploadUserType] = useState("all")
    const [userCategories, setUserCategories] = useState([])
    const fetchFriends = async () => {
        axios.get(`${getServerUrl()}/friends`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setFriendsList(response.data.filter(user => user.status === "ACCEPTED").map(user => user.friend.username))
            })
    }

    const fetchUserCategories = async () => {
        axios.get(`${getServerUrl()}/categories`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setUserCategories(response.data)
            })
    }

    useEffect(() => {
        fetchFriends()
        fetchUserCategories()
    }, [])

    const handleTypeChange = (event) => {
        setType(event.target.value);
    };

    const handleTripOrderChange = (event) => {
        setTripOrder(event.target.value);
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    const handleShouldShowSlideshowTitleChange = (event) => {
        setShouldShowSlideshowTitle(event.target.value);
    };

    const handleCategoryChange = (event) => {
        setCategory(event.target.value);
    };

    const handleUploadUserType = (event) => {
        setUploadUserType(event.target.value);
    };

    const handleFriendsChange = (event) => {
        const {
            target: { value },
        } = event;
        setFriends(typeof value === 'string' ? value.split(',') : value);
    };

    const handleSubmit = () => {
        if (step < 4) {
            setStep(step + 1);
        }else if (step ===4 && type === 'Photos'){
            setStep(5)
        } else {
            console.log({ type, filter, category, friends, startYear, endYear });
            onClose({
                type,
                tripOrder,
                category,
                friends,
                startYear,
                endYear,
                slideshowTitle,
                shouldShowSlideshowTitle,
                filter,
                uploadUserType
            });
        }
    };

    const handleBack = () => {
        setStep(step - 1)
    };

    const categories = [...userCategories.map(userCategory => userCategory.name), 'NFL', 'National Park'];


    return (
        <Dialog open={open} onClose={onClose} maxWidth="s" id="trip-pictures-slideshow-modal">
            <DialogTitle>{step === 1 ? 'Select Type' : 'Filter Options'}</DialogTitle>
            <DialogContent style={{width: 325}}>
                {step === 1 && (
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Choose one:</FormLabel>
                        <RadioGroup row value={type} onChange={handleTypeChange}>
                            <FormControlLabel value="Trips" control={<Radio />} label="Trips" />
                            <FormControlLabel value="Photos" control={<Radio />} label="Photos" />
                        </RadioGroup>
                    </FormControl>
                )}
                {step === 2 && (
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Choose one:</FormLabel>
                        <RadioGroup value={uploadUserType} onChange={handleUploadUserType}>
                            <FormControlLabel value="all" control={<Radio />} label={type === 'Trips' ? "View all trips" : "View all photos"} />
                            <FormControlLabel value="user" control={<Radio />} label={type === 'Trips' ? "Only view trips you created" : "Only view photos you uploaded"} />
                        </RadioGroup>
                    </FormControl>
                )}
                {step === 3 && (
                    <FormControl component="fieldset" fullWidth>
                        <RadioGroup value={filter} onChange={handleFilterChange}>
                            <FormControlLabel value="All" control={<Radio />} label="All" />
                            <FormControlLabel
                                value="Year"
                                control={<Radio />}
                                label={
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <span>Year</span>
                                        <div className="year-date-range">
                                        <TextField
                                            type="number"
                                            label="Start Year"
                                            value={startYear}
                                            onChange={(e) => setStartYear(Number(e.target.value))}
                                            inputProps={{ min: 1950, max: 2025 }}
                                            size="small"
                                            disabled={filter !== 'Year'}
                                        />
                                        <TextField
                                            type="number"
                                            label="End Year"
                                            value={endYear}
                                            onChange={(e) => setEndYear(Number(e.target.value))}
                                            inputProps={{ min: 1950, max: 2025 }}
                                            size="small"
                                            disabled={filter !== 'Year'}
                                        />
                                        </div>
                                    </Box>
                                }
                            />
                            <FormControlLabel
                                value="Category"
                                control={<Radio />}
                                label={
                                    <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                        <span>Category</span>
                                        <FormControl size="small" sx={{ minWidth: 200 }}>
                                            <Select
                                                value={category}
                                                onChange={handleCategoryChange}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Category' }}
                                                disabled={filter !== 'Category'}
                                            >
                                                <MenuItem value="" disabled>
                                                    Select a trip category
                                                </MenuItem>
                                                {categories.map((cat) => (
                                                    <MenuItem key={cat} value={cat}>
                                                        {cat}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                }
                            />
                            <FormControlLabel
                                value="Friends"
                                control={<Radio />}
                                label={
                                    <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                        <span>Friends</span>
                                        <FormControl size="small" sx={{ minWidth: 200 }}>
                                            <Select
                                                multiple
                                                value={friends}
                                                onChange={handleFriendsChange}
                                                displayEmpty
                                                disabled={filter !== 'Friends'}
                                                renderValue={(selected) =>
                                                    selected.length ? selected.join(', ') : 'Select a list of friends'
                                                }
                                            >
                                                <MenuItem disabled value="">
                                                    Select a list of friends
                                                </MenuItem>
                                                {friendsList.map((friend) => (
                                                    <MenuItem key={friend} value={friend}>
                                                        <Checkbox checked={friends.indexOf(friend) > -1} />
                                                        <ListItemText primary={friend} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                }
                            />
                        </RadioGroup>
                    </FormControl>
                )}
                {step === 4 && (
                    <FormControl component="fieldset">
                        <FormLabel component="legend">What order do you want your trips played?:</FormLabel>
                        <RadioGroup value={tripOrder} onChange={handleTripOrderChange}>
                            <FormControlLabel value="random" control={<Radio />} label="Random" />
                            <FormControlLabel value="recent" control={<Radio />} label="By Date (Most Recent)" />
                            <FormControlLabel value="oldest" control={<Radio />} label="By Date (Oldest first)" />
                        </RadioGroup>
                    </FormControl>
                )}
                {step === 5 && (
                    <FormControl component="fieldset" fullWidth>
                        <FormLabel component="legend">Do you want to add a title to your slideshow?:</FormLabel>
                    <RadioGroup value={shouldShowSlideshowTitle} onChange={handleShouldShowSlideshowTitleChange} className="slideshow-title">
                        <FormControlLabel value="no" control={<Radio />} label="No" />
                        <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label={
                                <Box display="flex" alignItems="center" gap={2}>
                                    <span>Yes</span>
                                        <TextField
                                            label="Add your slideshow title here"
                                            value={slideshowTitle}
                                            onChange={(e) => setSlideshowTitle(e.target.value)}
                                            size="small"
                                            disabled={shouldShowSlideshowTitle !== 'yes'}
                                        />
                                </Box>
                            }
                        />
                    </RadioGroup>
                    </FormControl>
                )}
            </DialogContent>
            <DialogActions>
                {(step > 1) && <Button onClick={handleBack}>Back</Button>}
                <Button variant="contained" onClick={handleSubmit}>
                    {((step === 4 && type === "Trips") || (step === 5 && type === 'Photos')) ? 'Submit' : 'Next'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}


export default TripPicturesSlideshowModal;